import { createIcon } from '../createIcon';
import { ReactComponent as IconPlus } from '../svg/plus.svg';

export default createIcon(IconPlus);
